export default __webpack_public_path__ + "static/media/rooster.16a189ab.png";